import { css } from 'styled-components';
import { map } from '../../breakpoint';
const validPositionValues = ['static', 'relative', 'absolute', 'fixed', 'sticky'];
export const position = () => css`
  ${_ref => {
  let {
    position
  } = _ref;
  return map(position, val => val !== undefined && css`
          position: ${val};
        `);
}};

  ${(_ref2 // eslint-disable-line  @typescript-eslint/no-explicit-any
) => {
  let {
    top
  } = _ref2;
  return map(top, val => val !== undefined && css`
          inset-block-start: ${val};
        `);
}};

  ${(_ref3 // eslint-disable-line  @typescript-eslint/no-explicit-any
) => {
  let {
    right
  } = _ref3;
  return map(right, val => val !== undefined && css`
          inset-inline-end: ${val};
        `);
}};

  ${(_ref4 // eslint-disable-line  @typescript-eslint/no-explicit-any
) => {
  let {
    bottom
  } = _ref4;
  return map(bottom, val => val !== undefined && css`
          inset-block-end: ${val};
        `);
}};

  ${(_ref5 // eslint-disable-line  @typescript-eslint/no-explicit-any
) => {
  let {
    left
  } = _ref5;
  return map(left, val => val !== undefined && css`
          inset-inline-start: ${val};
        `);
}};

  ${(_ref6 // eslint-disable-line  @typescript-eslint/no-explicit-any
) => {
  let {
    inset
  } = _ref6;
  return map(inset, val => val !== undefined && css`
          inset: ${val};
        `);
}};
`;